import * as React from 'react';
import { connect } from 'react-redux';
import { AccountProfilePage } from './Account-Profile/AccountProfile.page';
import { ProjectsPage } from './Projects-Profile/Projects.page';
import { Switch, Route } from 'react-router';
import { PageNotFound } from '../PageNotFound/PageNotFound';

import './ProfilePage.scss';
import { GlobalPrivateState } from 'src/api';

export interface ProfilePageProps {
}

export class ProfilePageComponent extends React.Component<ProfilePageProps> {
  public render() {
    return (
      <div className="page-profile">
        <Switch>
          <Route path="/profile/account" exact={true} component={AccountProfilePage} />
          <Route path="/profile/projects" exact={true} component={ProjectsPage} />
          <Route path="/profile/projects/:projectId" exact={true} component={ProjectsPage} />
          <Route path="/profile/projects/:projectId/edit" exact={true} component={ProjectsPage} />
          <Route path="/profile/projects/:projectId/delete" exact={true} component={ProjectsPage} />
          <Route path="/page-not-found" exact={true} component={PageNotFound} />
        </Switch> 
      </div>
    );
  }

}

export const ProfilePage = connect((state: GlobalPrivateState) => ({
}))(ProfilePageComponent);

export default ProfilePage;
